.wrap {
  position: fixed; left: 0; right: 0; z-index: 55; display: flex; justify-content: center; pointer-events: none;
  bottom: calc(var(--tabbar-height) + var(--tabbar-raise) + var(--tg-safe-bottom)); padding: var(--space-2) var(--space-6);
  transition: bottom 0.25s ease;
}
:global(:root[data-tabbar-hidden]) .wrap { bottom: var(--tg-safe-bottom); }
/* HQ-2213: экран с Snackbar на полях 8 (новости 772:30734 / 30737 / 30740 / 30776) ставит метку data-offline-gutter="8" */
:global(:root:has([data-offline-gutter='8'])) .wrap { padding-inline: var(--space-2); }
.banner {
  /* HQ-2213 v3: Snack View 345×64 (844:15849) — высота 64 при ×1, ×1.3 и ×2: строки по одной (ниже), поля сверху и снизу —
     остаток от 64 (при ×1 те же 12, при кегле ×1.3 — 6), содержимое по центру; min-width: 0 — строка без переноса
     не раздвигает карточку за поля (min-content flex-элемента) */
  flex: 1; min-width: 0; max-width: 448px; height: 64px; display: flex; align-items: center; gap: var(--space-3);
  padding: 0 var(--space-4) 0 var(--space-3); border-radius: 16px;
  background: var(--accent); color: var(--on-accent); pointer-events: auto;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 8px 24px rgba(0, 0, 0, 0.16);
}
.icon { flex: none; }
/* Figma «Middle»: sizing fill — текстовый блок тянется до правого поля 16 (HQ-1942) */
.text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
/* HQ-1112 v3: межстрочие в долях кегля — при 1× те же 20/16 px, при крупном шрифте строки растут вместе с кеглем;
   кегль растёт с системным до ×1.3 (20/16 px) и дальше не растёт.
   HQ-2213 v3: заголовок и подпись — по одной строке с «…», как Title / Subtitle Snackbar 844:15849 (раньше до 2 строк, и на
   360 текст матча «No connection. Showing data from …» поднимал плашку до 84 и накрывал строки списка) */
.title, .sub { display: block; min-width: 0; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.title { font-size: min(var(--fs-subheadline), 20px); line-height: 1.3334; font-weight: 500; }
/* HQ-1942: подпись — #212529@.52, как Snackbar I772:28492;12069:19772 (контраст 4.5:1 вне MVP, слово владельца 28.10) */
.sub { font-size: min(var(--fs-caption), 16px); line-height: 1.3334; color: rgba(33, 37, 41, 0.52); }
/* «Retry» — по своей ширине у левого края, не сжимается и не растягивается на строку */
.action { flex: none; align-self: flex-start; padding: 0; text-align: left; font-weight: 500; }
